import { Dialog, DialogProps } from "../core/components/dialog";
import { FieldInstance } from "../core/components/field";
import { IsNumericTextBox } from "../core/components/isNumericTextBox";
import { IsSearchField } from "../core/components/isSearchField";
import { Config } from "../core/config/config";
import { ComponentHelper } from "../core/util/componentHelper";
import { Helper } from "../core/util/helper";
import { NotificationHelper } from "../core/util/notificationHelper";
import { GridArticle } from "../tasks/workPackage/workPackage";
import React from "react"
import ReactDOM from "react-dom";

export const OpenEditArticleDialog = () => {
    return new Promise<GridArticle>((resolve, reject) => {
        const targetElement = $("<div>");
        const props: any = {
            onOk: (vm: GridArticle) => {
                resolve(vm)
            },
            onCancel: () => {
                ReactDOM.unmountComponentAtNode(targetElement[0]);
                targetElement[0].remove();
                reject();
            }
        }
        $("body").append(targetElement);
        ReactDOM.render(<EditArticleDialog {...props} />, targetElement[0]);
    })
}

class EditArticleDialog extends React.Component<{
    onOk: (vm: GridArticle) => void;
    onCancel: () => void;
}, {
    vm: GridArticle;
}>{
    private _factory = ComponentHelper.createFactory();
    private _dialogProps: DialogProps = {
        title: Helper.getTranslation("CustomerPortal.Approval.Actions.Edit"),
        actions: [
            //{
            //    label: Config.translations.cancel,
            //    action: () => { }
            //},
            {
                label: Config.translations.ok,
                action: () => {
                    if (this.isValid()) {
                        this.props.onOk(this.state.vm);
                    }
                    else {
                        NotificationHelper.showErrorMessage(Helper.getTranslation("Standard.PflichtfeldAllgemein"));
                        return false;
                    }
                },
                primary: true
            }
        ],
        afterClose: () => {
            this.props.onCancel();
        },
        width: 500
    };

    private isValid = (): boolean => {
        return true;
    }

    constructor(props) {
        super(props);
        let vm: GridArticle = {
            IsNew: false, IsWatchable: false, IsWatched: false, RecordRight: { CanRead: false, CanWrite: false },
            Anzahl: 1,
            Datum: new Date()
        }
        this.state = {
            vm: vm
        }
    }

    private getMessageLabel = () => {
        return <label>{Helper.getTranslation("Field.Material.Msg.EditNewMsg")}</label>;
    }

    private getQuantityNumericTextBox = () => {
        const props = this._factory.getDefaultNumericTextBoxProps();
        props.value = this.state.vm.Anzahl;
        props.field.min = 0;
        props.onChange = (_, value: any) => {
            let vm = this.state.vm;
            vm.Anzahl = value;
            this.setState({ vm: vm });
        }

        return <FieldInstance noHover={true} label={Helper.getTranslation("Field.Material.anzahl")}>
            <IsNumericTextBox {...props} />
        </FieldInstance>;
    }

    private getMaschNrIsSearchField = () => {
        const props = this._factory.getDefaultSearchFieldProps();
        props.value = this.state.vm.Maschnr;
        props.onChange = (_, value: any) => {
            let vm = this.state.vm;
            vm.Maschnr = value;
            this.setState({ vm: vm });
        }
        props.field.autocompleteEnabled = true;
        props.field.autocompleteTemplate = "<table cellspacing='0' style='table-layout:fixed; width:650px'><colgroup><col style='width: 100px' /><col style='width: 250px' /><col style='width: 300px' /></colgroup><tr style='background-color:# if(data.Status == 1) { #\\#cccccc# } else { #inherit# } #'><td style='vertical-align:top; word-wrap: break-word'>${data.MaschNr}</td># if(data.MaschBezeichnung != null) { #<td style='vertical-align:top'>${data.MaschBezeichnung}</td>#}else{#<td style='vertical-align:top'></td>#}#<td style='vertical-align:top'>${data.AdrName}</td></tr></table>";
        props.field.autocompleteUrl = "MachineLookup/Find";
        props.field.autocompleteDataTextField = "MaschNr";
        props.field.autocompleteAdditionalFilterParameterName = "adrNr";
        props.field.autocompleteAdditionalFilterParameter = "entity.Adrnr";
        props.field.searchButtonEnabled = false;
        props.field.searchWindowTitle = "{{{Maschine.Maschinensuche}}}";
        props.field.searchWindowUrl = "DynamicSearch/Window/Machine?adrnr={{entity.Adrnr}}";

        return <FieldInstance noHover={true} label={Helper.getTranslation("Field.Maschine.maschnr")}>
            <IsSearchField {...props} />
        </FieldInstance>;
    }

    render() {
        return (<>
            <Dialog {...this._dialogProps} open={true}>
                {this.getMessageLabel()}
                {this.getQuantityNumericTextBox()}
                {this.getMaschNrIsSearchField()}
            </Dialog>
        </>)
    }
}